import React, {Fragment} from "react"
import { Table } from "semantic-ui-react"
import Price from "components/Price/Price";
import shop from "shop/shop"
import Responsive from "react-responsive"

const PositionRow = ( { position, product } ) => {
  const useProductData = product && product.extras
  return (
    <Fragment>
      <Responsive minWidth={790}>
        <tr>
          <td className="bb ProductRowDefReturn">Kartons</td>
          <td className="tl bb ProductRowDefReturn">{position.count} {translate( "Stück" )} <br/>
            {/*<div className="black-60 d6 ">{position.count * position.unit_multi} {translate( "piece" )}</div>*/}
          </td>
          {/*<td className="tr bb ProductRowDefReturn">
            <div className="tr"><Price>{position.sum}</Price></div>
  </td>*/}
        </tr>
      </Responsive>
      <Responsive maxWidth={789}>
      <tr className={` ProductRowDefReturnMobile step `}>
          <td className="fw7 ">Artikel: </td>
          <td  className="bb b--black-20 tr"><strong>Kartons</strong></td>
        </tr>
        <tr className={`  ProductRowDefReturnMobile step`}>
          <td className="bb fw7 ProductRowDefReturnMobileLeft ">{translate( "Anzahl:" )} </td>
          <td  className="tr b--black-20 bb ProductRowDefReturnMobileRight ">{position.count}</td>
        </tr>
        {/*<tr className={`  ProductRowDefReturnMobile step `}>
          <td className="bb fw7 ProductRowDefReturnMobileLeft">
          {translate( "UVP:" )}
          </td >
        <td className="tr b--black-20 bb ProductRowDefReturnMobileRight">
          <Price>{position.sum}</Price>
          </td>
        </tr>*/}
      </Responsive>
    </Fragment>
  )
}

const SuccessTable = ( { positions, netto, byId, append = null, prepend = null } ) => {
  const tax = Number( netto ) / 100 * Number( shop.config.taxRate )
  const hasTax = shop.config.taxRate
  return (
    <Fragment>
            <Responsive minWidth={790}>
        <Table className="TableCustData" >
      <colgroup>
          <col width="50%"/>
          <col width="15%"/>
          {/*<col width="15%"/>*/}
      </colgroup>
      <Table.Header>
          <tr>
              <th className="tr">{translate( "Artikel" )}</th>
              <th style={{alignContent:"right",textAlign:"left"}} className="tr">{translate( "Anzahl" )}</th>
              {/*<th style={{alignContent:"right",textAlign:"right"}} className="tr">{translate( "UVP" )}</th>*/}
          </tr>
      </Table.Header>
        <Table.Body>
          {prepend && prepend}
          
          {positions.map( ( position ) => {
            const product = byId[ position.article_id ]
            return <PositionRow key={position.article_id} position={position} product={product}/>
          } )}
          
          {/*<Table.Row>
            <Table.Cell colSpan={4} className=" tr">
              <div className="tr f3 fw7" style={{color:"#917236"}}>{translate( "UVP:" )}</div>
            </Table.Cell>
            <Table.Cell>
              <div className="pv3 f3 tr "><Price>{netto}</Price></div>
            </Table.Cell>
        </Table.Row>*/}
          
          {append && append}
          {hasTax && <Table.Row>
            <Table.Cell colSpan={4} className=" tr">
              <div className="tr"><span className="f5  ">{translate( "zzgl. Steuern" )} ({shop.config.taxRate.replace( ".", "," )}%)</span></div>
            </Table.Cell>
            <Table.Cell>
              <div className="pv3 f3 tr "><Price>{tax}</Price></div>
            </Table.Cell>
          </Table.Row>}
          
          {hasTax && <Table.Row>
            <Table.Cell colSpan={4} className=" tr">
              <div className="tr"><span className="f5 b black">{translate( "inkl. Steuern" )}</span></div>
            </Table.Cell>
            <Table.Cell>
              <div className="pv3 f3 tr "><Price>{tax + Number( netto )}</Price></div>
            </Table.Cell>
          </Table.Row>}
        
        </Table.Body>
      </Table>
      </Responsive>
      <Responsive maxWidth={789}>
          <table className="TableCustData" >
            <colgroup>
              <col width="30%"/>
              <col width="70%"/>
              </colgroup>
            <tbody>
            {positions.map( ( position ) => {
            const product = byId[ position.article_id ]
            return <PositionRow key={position.article_id} position={position} product={product}/>
          } )}
          {/*<tr>
            <td className="bb fw7 f4 ProductRowDefReturn">{translate( "UVP:" )}</td>
            <td className="tr bb fw7 f4 ProductRowDefReturn"><Price>{netto}</Price></td>
        </tr>*/}
            </tbody>
          </table>
      </Responsive>
    </Fragment>
  )
}

export default SuccessTable


// WEBPACK FOOTER //
// ./src/components/Product/SuccessTableReturn.js